import { Module } from 'vuex';

export interface Network {
  id: number | null,
  created_at: string | null,
  updated_at: string | null,
  public_ip: string | null, 
  network_id: string | null,
  profile_id: string | null,
  name: string | null,
  country: string | null,
  region: string | null,
  isp: string | null,
  policy_id: number | null,
  user_id: number | null,
  devices: string[]
}
const defaultState: Network = {
  id: null,
  created_at: "",
  updated_at: "",
  public_ip: "",
  network_id: "",
  profile_id: "",
  name: "",
  country: "",
  region: "",
  isp: "",
  policy_id: null,
  user_id: null,
  devices: [],
};

const networkStore: Module<Network, {}> = {
  state: defaultState,
  mutations: {
    saveDetails(state, network: { id: number; public_ip: string; profile_id: string; network_id: string; name: string; country: string; isp: string; region: string; devices: string[]; user_id: number; policy_id: number; created_at: string; updated_at: string; }) {
      state.id = network.id;
      state.public_ip = network.public_ip;
      state.network_id = network.network_id;
      state.profile_id = network.profile_id;
      state.name = network.name;
      state.country = network.country;
      state.region = network.region;
      state.isp = network.isp;
      state.policy_id = network.policy_id;
      state.user_id = network.user_id;
      state.created_at = network.created_at;
      state.updated_at = network.updated_at;
      state.devices = network.devices;
    }
  },
  actions: {
    saveDetails({ commit }, network: { id: number; public_ip: string; profile_id: string; network_id: string; name: string; country: string; isp: string; region: string; devices: string[]; user_id: number; policy_id: number; created_at: string; updated_at: string; }) {
      // setTimeout(() => {
        commit('saveDetails', network);
      // }, 50);
    }
  }
};

export default networkStore;
